import React, { useState } from 'react';
import logo from '../logo_colored_transp_no_text.png';
import LoginForm from './LoginForm'; // helyes útvonal

const Navbar = () => {
  const [showLogin, setShowLogin] = useState(false);

  const handleMouseEnter = (e) => {
    e.target.style.backgroundColor = '#f2f2f2';
    e.target.style.transform = 'scale(1.05)';
  };

  const handleMouseLeave = (e) => {
    e.target.style.backgroundColor = 'white';
    e.target.style.transform = 'scale(1)';
  };

  return (
    <>
      <nav
        style={{
          backgroundColor: '#b30000',
          padding: '0.5rem 2rem',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          color: 'white',
          fontFamily: 'Arial, sans-serif',
          position: 'relative'
        }}
      >
        {/* Bal oldal: logo + cím + navigáció */}
        <div style={{ display: 'flex', alignItems: 'center', gap: '1rem' }}>
          <img
            src={logo}
            alt="Archery Nexus Logo"
            style={{
              height: '50px',
              width: 'auto'
            }}
          />

          <div style={{ display: 'flex', alignItems: 'center', gap: '1.5rem' }}>
            <a
              href="/"
              style={{
                fontSize: '1.5rem',
                fontWeight: 'bold',
                color: 'white',
                textDecoration: 'none'
              }}
            >
              Archery Nexus
            </a>
            <div style={{ display: 'flex', gap: '1rem', fontWeight: 'bold' }}>
              <a href="/versenyek" style={{ color: 'white', textDecoration: 'none' }}>Versenyek</a>
              <a href="/kapcsolat" style={{ color: 'white', textDecoration: 'none' }}>Kapcsolat</a>
              <a href="/adatvedelem" style={{ color: 'white', textDecoration: 'none' }}>Adatkezelési Tájékoztató</a>
            </div>
          </div>
        </div>

        {/* Jobb oldal: Bejelentkezés gomb 👤 + hover effekt */}
        <div>
          <button
            onClick={() => setShowLogin(true)}
            onMouseEnter={handleMouseEnter}
            onMouseLeave={handleMouseLeave}
            style={{
              backgroundColor: 'white',
              color: '#b30000',
              padding: '0.4rem 0.8rem',
              borderRadius: '5px',
              textDecoration: 'none',
              fontWeight: 'bold',
              fontSize: '0.9rem',
              transition: 'all 0.3s ease',
              border: 'none',
              cursor: 'pointer'
            }}
          >
            👤 Bejelentkezés
          </button>
        </div>
      </nav>

      {/* Feltételesen megjelenő bejelentkezési űrlap */}
      {showLogin && <LoginForm onClose={() => setShowLogin(false)} />}
    </>
  );
};

export default Navbar;
